<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-clock-history">&nbsp; <i class="bi-box"></i> &nbsp; Supply Log</h5>
        </div>
        <div class="col-auto p-0 text-center">
          <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="loadSupplyLog()" :disabled="loading">&nbsp; Reload</button>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- ----------------------------------------------- -->                    
      <div class="row p-0">

        <div class="col-3 p-0">
          <div class="input-group w-100">
            <span class="input-group-text w-25">Branch</span>
            <select class="form-select" v-model="branch" @change="loadSupplyLog()">
              <option value="*">All Branches</option>
              <option v-for="b in branches" :key="b._id" :value="b._id">{{ b.name }}</option>
            </select>
          </div>
        </div>

        <div class="col-8 p">
          <div class="input-group w-100">
            <span class="input-group-text">From</span>
            <input class="form-control w-20" type="date" v-model="from">
            <span class="input-group-text">To</span>
            <input class="form-control w-20" type="date" v-model="to">
            <button class="btn btn-primary bi-filter" @click="loadSupplyLog()" :disabled="loading"></button>
          </div>
        </div>
        
        <div class="col p-0">
        </div>

      </div>
    </div>
    <!-- =========================================================================================================== -->
    <table class="table table-sm table-bordered table-striped table-hover table-fixed">
      <!-- ----------------------------------------------- -->
      <thead>
        <tr class="table-dark">
          <th class="">Branch</th>
          <th class="w-25">Product</th>
          <th class="w-10 text-center">Amount</th>
          <th class="w-10 text-center">Prod Date</th>
          <th class="w-15">Time</th>
          <th class="w-25">Notes</th>
        </tr>
      </thead>
      <!-- ----------------------------------------------- -->
      <tbody style="height: calc(100vh - 190px)">        
        <tr v-for="log in logs" :key="log._id">
          <td class="">{{ log.branch }}</td>
          <td class="w-25">{{ log.product }}</td>
          <td class="w-10 text-center">{{ log.amount }}</td>
          <td class="w-10 text-center">{{ log.prod_date }}</td>
          <td class="w-15">{{ log.timestamp }}</td>
          <td class="w-25">{{ log.notes }}</td>
        </tr>
      </tbody>
      <!-- ----------------------------------------------- -->
    </table>
  </div>

</template>
<!-- ******************************************************** -->
<script>
  export default {
    name: 'SupplyLog',
    data(){
      return {
        loading: false,
        logs: [],
        branches: [],

        branch: '*',
        searchKey: '',
        from: '',
        to: '',
      }
    },
    async created() {
      await this.loadBranches();
      this.from = this.$getMonthStart();
      this.to = this.$getMonthEnd();
      this.loadSupplyLog();
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async loadBranches(){
        this.loading = true;
        this.branches = [];
        var ack = await this.$service.getBranchesAbstract();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.branches = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
      async loadSupplyLog(){
        this.loading = true;
        this.logs = [];
        var ack = await this.$service.getSupplyLog({
          searchKey: this.searchKey,
          branch: this.branch,
          from: this.from,
          to: this.to,
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.logs = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
</style>
  